import React, { useEffect, useState } from 'react';
import { motion, useAnimation } from 'framer-motion';

const AboutHeader = () => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const controls = useAnimation();

  useEffect(() => {
    if (!hasLoaded) {
      controls.start({ opacity: 1, y: 0, transition: { duration: 1 } });
      setHasLoaded(true);
    }
  }, [controls, hasLoaded]);

  return (
    <div className='mt-10 mx-auto flex max-w-5xl items-center justify-center p-4 lg:px-8 '>
      <div>
        <div className="flex justify-center w-full items-center bg-black">
          {/* <motion.div
            initial={{ opacity: 0, y: 50 }} // Adjust the initial position (y: 50)
            animate={controls}
            className="w-5 h-5 rounded-full bg-white animate-bounce"
          ></motion.div> */}
          {/* <motion.p
            initial={{ opacity: 0, y: 50 }} // Adjust the initial position (y: 50)
            animate={controls}
            className='title-p text-white text-[20px] leading-6 ml-4'
          >
            AVAILABLE FOR FREELANCE
          </motion.p> */}
        </div>
        <div className="w-full mt-12">
          <motion.h1
            initial={{ opacity: 0, y: 50 }} // Adjust the initial position (y: 50)
            animate={controls}
            className='text-white hero-text text-center lg:text-[152px] md:text-[90px] md:leading-[70px] text-[54px] lg:leading-[128px] leading-[50px]'
          >
            JUNIOR
          </motion.h1>
          <motion.h1
            initial={{ opacity: 0, y: 50 }} // Adjust the initial position (y: 50)
            animate={controls}
            className='text-white hero-text mt-3 lg:text-[152px] md:text-[90px] md:leading-[70px] text-[54px] lg:leading-[128px] leading-[50px] text-center'
          >
           FRONTEND DEVELOPER
          </motion.h1>
         
        </div>
      </div>
    </div>
  );
};

export default AboutHeader;
